import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./registerServiceWorker";
import settings from "./backend/LocalSettings";
import VueResource from "vue-resource";
import VueI18n from "vue-i18n";
import messages from "./language/lang";
import locale from "element-ui/lib/locale/lang/en"
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import rights from "./backend/RightsHelper";

if ('-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style) { // detect it's IE11
  window.addEventListener("hashchange", function(event) {
    var currentPath = window.location.hash.slice(1);
    // if (store.state.route.path !== currentPath) { // store is undefined?
    router.push(currentPath)
    // }
  }, false)
}

Vue.prototype.$rights = rights;
Vue.config.productionTip = false;
Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: window.localStorage.getItem("locale") || "en", // set locale
  messages // set locale messages
});

Vue.use(VueResource);
Vue.use(ElementUI, { locale });

Vue.http.options.xhr = { withCredentials: true };
Vue.http.options.emulateJSON = true;
Vue.http.headers.common["Token"] = settings.get_token();

Vue.http.options.root = "https://textiles-market.com/api/index.php/";

Vue.filter('format_money', function (value) {
  var numeral = require('numeral')
  if (value !== undefined) {
    return numeral(value).format('0,0.00')
  } else {
    return null
  }
})

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount("#app");